<template>
  <section>
    <div id="LastConfigured" ref="LastConfigured" class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <div class="label-headline">{{ $t("Wishlist.configure.title") }}</div>
          <hr class="border-for-section" />
        </div>
      </div>
      <div class="row">
        <div
          class="col-1 arrow-col"
          :class="{ hidden: !scrollValues || !scrollValues.arrowLeft }"
        >
          <i
            v-if="scrollValues && scrollValues.arrowLeft"
            class="icon-arrow-left"
            :ref="'arrow-left'"
            @click="scroll('left')"
          >
            <img
              :src="appUrl + '/img/menu/arrow-right.svg'"
              height="19"
              width="9"
            />
          </i>
        </div>
        <div
          class="col-item-list"
          :class="{
            'col-12': !scrollValues,
            'col-11':
              scrollValues &&
              ((scrollValues.arrowRight && !scrollValues.arrowLeft) ||
                (!scrollValues.arrowRight && scrollValues.arrowLeft)),
            'col-10':
              scrollValues &&
              (scrollValues.arrowRight || scrollValues.arrowLeft),
          }"
        >
          <div
            class="list-row no-scrollbar"
            ref="ListRow"
            @scroll="scrollBrowser()"
          >
            <div ref="ItemList" class="list-col">
              <template v-if="wishlists[currentWishlist].length > 0">
                <template
                  v-for="(item, itemIndex) in wishlists[currentWishlist]"
                >
                  <img
                    :src="getSrc(item)"
                    :ref="'lastConfigured' + itemIndex"
                    @error="
                      $refs['lastConfigured' + itemIndex][0]
                        ? ($refs['lastConfigured' + itemIndex][0].src =
                            appUrl + '/img/assets/not-available.jpg')
                        : ''
                    "
                    @click="configure(item.primaryKey)"
                    v-bind:key="itemIndex"
                    :title="getTitle(item)"
                    class="thumb"
                    :alt="
                      item.items
                        .map((a) => a.itemnumber)
                        .join('_')
                        .toUpperCase()
                    "
                  />
                </template>
              </template>
              <p v-else class="text-center last-configured-empty">
                {{ $t("Empty.noItems") }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="col-1 arrow-col"
          :class="{ hidden: !scrollValues || !scrollValues.arrowRight }"
        >
          <i
            v-if="scrollValues && scrollValues.arrowRight"
            class="icon-arrow-right"
            :ref="'arrow-right'"
            @click="scroll('right')"
          >
            <img
              :src="appUrl + '/img/menu/arrow-right.svg'"
              height="19"
              width="9"
            />
          </i>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config from "@/vuex/Config";
import DAOWishlist from "@/../public/js/DAO/Wishlist.js";
import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Logger from "@/assets/Helper/Logger";
import Slider from "@/assets/Helper/Slider";

export default {
  name: "LastConfigured",
  data() {
    return {
      config: Config.getters.getConfig,
      getApiHost: Config.getters.getApiHost,
      appUrl: Config.getters.getAppUrl,
      set: SetData.getters.getSet,
      itemWidth: 13,
      currentWishlist: "configure",
      scrollValues: false,
      scrollStep: 130,
      wishlists: {
        configure: [],
      },
    };
  },
  components: {},
  watch: {
    "wishlists.configure": {
      handler: function () {
        setTimeout(() => {
          this.$forceUpdate();
        }, 500);
      },
      deep: true,
    },
  },
  updated() {
    if (this.scrollValues === false) {
      let nodeWidth = this.$refs["ItemList"].offsetWidth;
      let parentNodeWidth = this.$refs["ListRow"].offsetWidth;
      this.scrollValues = {
        nodeWidth: nodeWidth,
        parentNodeWidth: parentNodeWidth,
        left: 0,
        arrowRight: nodeWidth > parentNodeWidth,
        arrowLeft: false,
      };
    }
  },
  mounted() {
    this.getOverview();

    const slider = this.$refs.ListRow;
    Slider.setSlider(slider);
    //this.$refs["LastConfigured"].scrollIntoView();
  },
  methods: {
    getTitle: function (item) {
      return (
        this.$d(item.date, "dateTime") +
        "\n" +
        (item.setId !== "" ? item.setId + "\n" : "") +
        item.items
          .map((a) => a.itemnumber)
          .join("_")
          .toUpperCase() +
        "\n" +
        this.$n(item.totalPrice, "currency")
      );
    },
    scrollBrowser: function () {
      this.scrollValues.left = this.$refs["ListRow"].scrollLeft;

      if (this.scrollValues.left < 1) {
        this.scrollValues.arrowLeft = false;
      } else {
        this.scrollValues.arrowLeft = true;
      }

      if (this.isLastScrollStep()) {
        this.scrollValues.arrowRight = false;
      } else {
        this.scrollValues.arrowRight = true;
      }

      if (
        this.scrollValues.left < 1 &&
        this.scrollValues.nodeWidth > this.scrollValues.parentNodeWidth
      ) {
        this.scrollValues.arrowRight = true;
      }

      this.$forceUpdate();
    },
    scroll: function (direction) {
      if (direction === "right") {
        this.$refs["ListRow"].scrollLeft += this.scrollStep;
        this.scrollValues.left += this.scrollStep;
        this.scrollValues.arrowLeft = true;
      } else {
        this.$refs["ListRow"].scrollLeft -= this.scrollStep;
        this.scrollValues.left -= this.scrollStep;
        this.scrollValues.arrowRight = true;
      }

      if (this.scrollValues.left < 1) {
        this.$refs["ListRow"].scrollLeft = 0;
        this.scrollValues.left = 0;
        this.scrollValues.arrowLeft = false;
      }

      if (
        this.scrollValues.left < 1 &&
        this.scrollValues.nodeWidth > this.scrollValues.parentNodeWidth
      ) {
        this.scrollValues.arrowRight = true;
      }

      if (this.isLastScrollStep()) {
        this.scrollValues.arrowRight = false;
      }

      this.$forceUpdate();
    },
    isLastScrollStep: function () {
      return (
        this.scrollValues.parentNodeWidth >=
          this.scrollValues.nodeWidth - this.scrollValues.left - 1 ||
        this.scrollValues.nodeWidth - this.scrollValues.parentNodeWidth <=
          this.scrollStep
      );
    },
    getSrc: function (item) {
      let tmpItems = [];
      let j = 0;
      for (let i in item.items) {
        tmpItems[j] = { itemnumber: item.items[i].itemnumber };
        j++;
      }

      if (tmpItems.length > 0) {
        return (
          this.getApiHost +
          "/v2/images/item/ffffff/600/600/" +
          tmpItems
            .map((a) => a.itemnumber)
            .join("_")
            .toUpperCase() +
          ".jpg"
        );
      } else {
        if (
          this.set.items[0].description.stones &&
          this.set.items[0].description.stones.diamondStock
        ) {
          return (
            this.appUrl +
            "/img/assets/stones/exchange/stone_" +
            this.set.items[0].description.stones.diamondStock.stoneform.toLowerCase() +
            ".jpg"
          );
        } else {
          return this.appUrl + "/img/assets/stones/exchange/stone_a.jpg";
        }
      }
    },
    configure: function (primaryKey) {
      Status.dispatch("setLoading", true);

      DAOWishlist.getByPrimaryKey(this.currentWishlist, primaryKey).then(
        (wishlistData) => {
          wishlistData.wishlistItemId = primaryKey;

          Status.dispatch("setIsInit", true);
          SetData.dispatch("setItemDescription3d", {});

          SetData.dispatch("restoreWishlistData", wishlistData)
            .then(() => {
              if (
                SetData.getters.getShowSetImage === true &&
                this.config.visualMode !== "images"
              ) {
                this.$parent.$parent["setCurrentItem"]("set");
              } else {
                this.$parent.$parent["setCurrentItem"]("overview");
              }

              Config.dispatch("setVisualMode", "show");

              document.location.reload();
            })
            .catch((error) => {
              Logger.error(error);

              Status.dispatch("setLoading", false);
            });
        }
      );
    },
    getOverview: function () {
      let componet = this;
      DAOWishlist.getAll("configure").then((items) => {
        componet.$data.wishlists.configure = items;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  section {
    position: relative;
  }

  #LastConfigured {
    margin-top: 1.5rem;
    margin-bottom: 4rem;
    background-color: $darkGrey;

    @media (min-width: 1200px) {
      margin-bottom: 0;
      background-color: #ffffff;
    }

    .arrow-col {
      display: flex;
      justify-content: center;

      /*
      &:has(.icon-arrow-right) {
        justify-content: flex-end;
      }
       */
    }

    .list-row {
      overflow: auto;
      scroll-behavior: smooth;
      border-top: none;
      cursor: pointer;
      text-align: center;
    }

    .list-col {
      margin-top: 0;
      overflow: hidden;
      width: max-content;

      p {
        line-height: 5rem;
      }

      .thumb:first-child {
        margin-left: 0;
      }

      .thumb:first-child {
        margin-left: 0;
      }
    }

    .label-headline {
      font-weight: bold;
      margin-top: 2rem;
    }

    hr.border-for-section {
      border-color: $darkGrey;
      margin-top: 1em;
    }

    .thumb {
      display: inline-block;
      margin: 1.5rem;
      border-color: $imgBorderGrey;
      width: 10rem;
      cursor: pointer;
      height: auto;
    }

    .icon-arrow-left,
    .icon-arrow-right {
      display: inline-flex;
      border: none;
      z-index: 1001;
      font-size: 2.5rem;
      cursor: pointer;
    }

    .icon-arrow-left img {
      transform: rotate(180deg);
    }

    .list-col:has(.last-configured-empty) {
      margin: auto;
    }
  }
}
</style>
